import { render, staticRenderFns } from "./LoanRuleDrawer.vue?vue&type=template&id=5c3576ca&"
import script from "./LoanRuleDrawer.vue?vue&type=script&lang=ts&"
export * from "./LoanRuleDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./LoanRuleDrawer.vue?vue&type=style&index=0&id=5c3576ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports